export const shareButton = { cy: 'share-button-btn' };
export const changeButtonDataSet = { cy: 'change-share-button' };
